import React from 'react';
import { PhoneIcon, CheckCircleIcon } from 'lucide-react';
export function Home() {
  return <section id="home" className="relative min-h-screen flex items-center justify-center bg-cover bg-center" style={{
    backgroundImage: 'url(https://uploadthingy.s3.us-west-1.amazonaws.com/6LM6vKTn8hbvaQMAS4tfz3/hero-banner-bg2.png)'
  }} data-id="element-299">
      {/* Dark overlay for better text readability */}
      <div className="absolute inset-0 bg-black/70" data-id="element-300"></div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center text-white" data-id="element-301">
        <p className="text-sm md:text-base uppercase tracking-wider mb-4 text-gray-300" data-id="element-302">
          AUTO REPAIR | TRUCK REPAIR | DIESEL ENGINE REPAIR
        </p>
        <h1 className="text-5xl md:text-7xl font-bold mb-6 drop-shadow-2xl" data-id="element-303">
          Garrett Auto and Truck Service, Inc
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto drop-shadow-lg" data-id="element-304">
          Expert automotive and truck repair services in Farmington Hills since
          1958
        </p>

        <a href="tel:2484788382" className="inline-flex items-center bg-white hover:bg-gray-100 text-[#B1050B] px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-xl mb-12" data-id="element-305">
          <PhoneIcon size={24} className="mr-2" data-id="element-306" />
          Call Us (248) 478-8382
        </a>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto mt-12" data-id="element-307">
          {/* Save Time & Money */}
          <div className="bg-black/50 backdrop-blur-sm border-2 border-[#D4AF37] rounded-lg p-6 text-left" data-id="element-308">
            <div className="bg-[#D4AF37] w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-309">
              <CheckCircleIcon size={24} className="text-black" data-id="element-310" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-311">Save Time & Money</h3>
            <p className="text-gray-300" data-id="element-312">
              The "cheaper" mechanic down the road doesn't stand behind their
              repairs, parts and labor like we do.
            </p>
          </div>

          {/* Accurate Diagnosis */}
          <div className="bg-black/50 backdrop-blur-sm border-2 border-[#D4AF37] rounded-lg p-6 text-left" data-id="element-313">
            <div className="bg-[#D4AF37] w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-314">
              <CheckCircleIcon size={24} className="text-black" data-id="element-315" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-316">Accurate Diagnosis</h3>
            <p className="text-gray-300" data-id="element-317">
              Taking your vehicle somewhere else can cost more in extra trips,
              lost earnings, and repairs that should have been done right the
              first time.
            </p>
          </div>

          {/* Convenient Location */}
          <div className="bg-black/50 backdrop-blur-sm border-2 border-[#D4AF37] rounded-lg p-6 text-left" data-id="element-318">
            <div className="bg-[#D4AF37] w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-319">
              <CheckCircleIcon size={24} className="text-black" data-id="element-320" />
            </div>
            <h3 className="text-xl font-bold mb-3" data-id="element-321">Convenient Location</h3>
            <p className="text-gray-300" data-id="element-322">
              Serving Farmington, Farmington Hills, Novi, Commerce, Walled Lake,
              Livonia and surrounding areas.
            </p>
          </div>
        </div>
      </div>
    </section>;
}